import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("oits_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Weather providers expect one location, not an itinerary's full city list.
  // Resolve the first listed city so multi-stop destinations (e.g. Tbilisi,
  // Gudauri, Batumi) still receive a valid weather lookup.
  if (config.url?.replace(/\/$/, "").endsWith("/weather") && config.params?.city) {
    const rawCity = String(config.params.city).trim();
    const firstCity = rawCity.split(/[,;|/–—]/)[0].trim();
    config.params = { ...config.params, city: firstCity || rawCity };
  }

  return config;
});
